module.exports = __webpack_public_path__ + "static/media/Avvale-logo-ver.5d3aedc6.svg";